import SiafLiteApiRepository from "../../external/siafLiteApi";

class ContasPagarPagamentosService {
  constructor() {
    this.urlBase = "/financeiro/contas-pagar-pagamentos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  removerPagamentos(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/remover-pagamentos-contas-pagar`
    ).post(body);
  }
}

export default ContasPagarPagamentosService;
